<template>
    <div class="share">
        <!-- 渲染详情页 -->
        <router-view></router-view>

        <!-- 八字分享:type为2时候 -->
        <van-popup class="share-change-group-popup" :value=showShareChangePop v-bind:close-on-click-overlay="false">
            <div class="share-cgpp-title">确定八字名称或分组</div>
            <div class="share-cgpp-item">
                <label class="collate-form-label cf-label-two">姓 名</label>
                <input class="collate-form-input" type="text" maxlength="15" placeholder="输入称呼" @input="changeName" @blur="blurNameInput" v-model="shareFormData.f_name" autofocus>
            </div>
            <div class="share-cgpp-item" @click="chooseGroup">
                <label class="collate-form-label cf-label-two">分 组</label>
                <div class="share-cgpp-choose">
                    <span v-if="shareFormData.group" class="share-cgpp-text-have">{{shareFormData.group.slice(0, 10)}}</span>
                    <span v-else class="share-cgpp-text">选择分组</span>
                    <i class="cf-icon-right iconfont icon-xiangyou"></i>
                </div>
            </div>
            <div class="share-cgpp-button" @click="confirmChange">确定</div>
        </van-popup>

        <!-- 八字分享:type为3的时候 -->
        <van-popup class="share-select-same-popup" :value=showShareSelectPop v-bind:close-on-click-overlay="false">
            <div class="share-sspp-title">已存在四柱相同但不同名的八字<br>请选择操作</div>
            <div class="share-sspp-list">
                <div class="share-sspp-item" v-for="data in shareSeletedListData" v-bind:key="'share_item_' + data.f_name + Math.random(0, 10)" @click="clickSelectedFate(data)">
                    打开命主：{{data.f_name.slice(0, 8)}}({{data.sex == 0 ? '乾' : '坤'}})
                    <i class="iconfont icon-arrow-you share-sspp-icon"></i>
                </div>
            </div>
            <div class="share-cgpp-button" @click="saveNewFate">保存为新八字</div>
        </van-popup>

        <!-- 其他分享:批盘、反馈、反馈对照 -->
        <!-- 多列表弹框 -->
        <vant-share-select-pop 
            v-if="showOtherShareSelectPop"
            v-bind:shareType="shareType"
            v-bind:showPop="showOtherShareSelectPop"
            v-bind:selectedList="otherShareSelectedList"
            v-bind:selectItemFunc="clickOtherShareSelectedItem"
            v-bind:overlayClickClose="true"
            v-bind:overlayFunc="clickShareSelectOverlay"
            v-bind:saveToNewFunc="clickOtherShareSelectSaveToNew">
        </vant-share-select-pop>

        <!-- 确定新名称分组弹框 -->
        <vant-share-change-pop 
            v-if="showOtherShareChangePop"
            v-bind:shareType="shareType"
            v-bind:showPop="showOtherShareChangePop"
            v-bind:shareFormData="otherShareFormData"
            v-bind:overlayClickClose="false"
            v-bind:chooseGroupFunc="shareChooseGroup"
            v-bind:confimChangeFunc="shareConfirmChange">
        </vant-share-change-pop>

        <!-- 确定保存名称弹框 -->
        <vant-share-save-pop 
            v-if="showOtherShareSavePop"
            v-bind:shareType="shareType"
            v-bind:showPop="showOtherShareSavePop"
            v-bind:shareFormData="otherShareSaveData"
            v-bind:overlayClickClose="false"
            v-bind:confirmFunc="shareConfirmSave">
        </vant-share-save-pop>

    </div>
</template>

<script>
import VantShareSelectPop from '../layouts/vant/VantShareSelectPop.vue'
import VantShareChangePop from '../layouts/vant/VantShareChangePop.vue'
import VantShareSavePop from '../layouts/vant/VantShareSavePop.vue'
import { SHARE } from '../modules/share';
import { DOM, LOADING_DOM } from '../modules/dom';
export default {
    name: 'Share',
    components: {VantShareSelectPop, VantShareChangePop, VantShareSavePop},
    computed: {
        showShareChangePop() {
            return this.$store.state.share.showShareChangePop;
        },
        shareFormData() {
            return this.$store.state.share.shareFormData;
        },
        showShareSelectPop() {
            return this.$store.state.share.showShareSelectPop;
        },
        shareSeletedListData() {
            return this.$store.state.share.shareSeletedListData;
        },
        otherShareData() {
            return this.$store.state.othershare.shareData;
        },
        showOtherShareSelectPop() {
            return this.$store.state.othershare.showShareSelectPop;
        },
        otherShareSelectedList() {
            return this.$store.state.othershare.shareSelectedList;
        },
        showOtherShareChangePop() {
            return this.$store.state.othershare.showShareChangePop;
        },
        otherShareFormData() {
            return this.$store.state.othershare.shareFormData;
        },
        showOtherShareSavePop() {
            return this.$store.state.othershare.showShareSavePop;
        },
        otherShareSaveData() {
            return this.$store.state.othershare.shareSaveData;
        }
    },
    data() {
        return {
            shareType: 1,
        }
    },
    beforeCreate: function() {
        // 容错处理:如果只是在share目录下的话就直接跳转到record界面，无shareId的状态
        var curPath = this.$router.history.current.path;
        if(curPath == '/share'){
            this.$router.replace('/record');
        }
    },
    created: function() {
        var me = this,
            params = this.$router.history.current.params,
            curPath = this.$router.history.current.path,
            pathArr = curPath.split('/'),
            shareType = pathArr[2] ? pathArr[2] : '';
        console.log('---------created', params, curPath, pathArr, shareType)
        
        // 分别处理不同类型的分享
        switch(shareType) {
            case 'detail':
                this.initDetailShare(params);
                break;
            case 'comment':
                this.shareType = 3;
                this.initCommentShare(params);
                break;
            case 'discuss':
                this.shareType = 6;
                this.initDiscussShare(params);
                break;
            case 'famouspediaread':
                this.initFamousPediaShare(params);
                break;
            case 'diagramdetail':
                this.initDiagramDetailShare(params);
                break;
            case 'marriagereportone':
            case 'marriagereporttwo':
                this.initMarriageReportShare(params);
                break;
            default:
                break;
        }
    },
    methods: {
        // 八字分享
        initDetailShare(params) {
            // share/detail/muhuo_fc2ecf7412737abc769bdd2d292f1814_119604
            if(params && params['id'] && params['id'].indexOf('muhuo') != -1){
                var id = params['id'], shareId, saveStatus,
                    arr = id.indexOf('save') != -1 ? id.split('save') : [];
                
                // 处理是否自动保存的逻辑
                if(arr.length > 0){
                    // 有带save值
                    shareId = arr[0].split('-')[0]; saveStatus = parseInt(arr[1]);
                }else{
                    // 不带save值:for Android 为自动保存;
                    shareId = id; saveStatus = 1;
                }

                var me = this, 
                    shareData = { code: shareId, save: saveStatus };
                // 初始化分享页面的时候默认拉取分组数据
                this.$store.dispatch('initBasicData');
                this.$store.dispatch('group/initGroupList');
                setTimeout(() => {
                    me.$store.dispatch('share/showSharedDetail', shareData);
                }, 500);
            }
        },
        initCommentShare(params) {
            // share/comment/muhuob_3f0581e1aa4e1d8f93a326fc7011cb68_10002
            console.log('initCommentShare-----', params)
            var me = this,
                shareId = params['id'],
                shareData = { code: shareId }; 
            if(params && params['id'] && params['id'].indexOf('muhuo') != -1){
                this.$store.dispatch('initBasicData');
                setTimeout(() => {
                    me.$store.dispatch('othershare/showCommentShare', shareData);
                }, 500);
            }else {
                this.$toast('获取数据失败!');
                this.$router.replace('/record');
            }
        },
        initDiscussShare(params) {
            // share/discuss/muhuolp_7913b67bea4bbd317133c8bef04efc81_6
            var me = this,
                shareId = params['id'],
                shareData = { code: shareId }; 
            if(params && params['id'] && params['id'].indexOf('muhuo') != -1){
                this.$store.dispatch('initBasicData');
                this.$store.dispatch('group/initGroupList');
                setTimeout(() => {
                    me.$store.dispatch('othershare/showDiscussShare', shareData);
                }, 500);
            }
        },
        initFamousPediaShare(params) {
            var shareId = params['id'];
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('search/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                baikeId: shareId
            });
        },
        initDiagramDetailShare(params) {
            var shareId = params['id'];
            this.$store.dispatch('diagram/resetDiagramFormData');
            this.$store.dispatch('diagram/resetDiagramInfo');
            this.$store.dispatch('diagram/initDiagramInfo', {
                dCode: shareId
            });
        },
        initMarriageReportShare(params) {
            var shareId = params['id'];
            console.log('initMarriageReportShare----', shareId);
            this.$store.dispatch('marriage/resetMarriageData');
            this.$store.dispatch('marriage/getMarriageInfoByShareCode', { 
                mCode: shareId
            });
        },
        chooseGroup() {
            var curPath = this.$router.history.current.path;
            this.$router.replace(curPath + '/choosegroup');
        },
        changeName() {
            this.$store.state.share.shareChanged = true;
        },
        blurNameInput() {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 20);
        },
        confirmChange() {
            if(this.$store.state.share.shareChanged){
                this.$store.state.share.showShareChangePop = false;
                LOADING_DOM.showLoading();
                this.$store.dispatch('share/changeSharedNameGroup', {
                    sucCb: function() {
                        LOADING_DOM.hideLoading();
                    }
                });
            }else{
                this.$store.state.share.showShareChangePop = false;
            }
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 20);
        },
        clickSelectedFate(data){
            this.$store.dispatch('detail/initDetail', data);
            // 更新列表数据
            AppFate.$store.dispatch('record/updateRecordListData', data);
            this.$router.replace('/detail/record/' + data.id);
        },
        saveNewFate() {
            // 保存为新八字的时候要再弹一次修改名字和分组的框
            this.$store.state.share.showShareSelectPop = false;
            this.$store.state.share.showShareChangePop = true;
            this.$store.state.share.shareChanged = true;
            this.$store.state.share.shareFormData = Object.assign({}, this.$store.state.share.shareNewFormData);
        },
        // 其他分享:批盘、反馈、论盘
        clickShareSelectOverlay() {
            this.$store.state.othershare.showShareSelectPop = false;
        },
        clickOtherShareSelectedItem(data) {
            console.log('clickOtherShareSelectedItem------', data)
            var me = this;
            this.$store.state.othershare.showShareSelectPop = false;
            switch(this.otherShareData.shareType){
                case 3:
                    this.$store.dispatch('othershare/triggerSaveToHave', {
                        data: data,
                        cb: function(){                   
                            // todo:走配置信息:根据批盘论盘type值来配
                            me.$toast('已自动保存到对应八字下面\n『他人批盘』中');
                        }
                    });
                    break;
                case 6:
                case 7:
                    this.$store.dispatch('othershare/triggerSaveDiscussToHave', data)
                    break;
            }
        },
        clickOtherShareSelectSaveToNew() {
            // 保存为新的
            this.$store.state.othershare.showShareSelectPop = false;
            this.$store.dispatch('othershare/triggerSaveToNew')
        },
        clickShareChangeOverlay() {
            this.$store.state.othershare.showShareChangePop = false;
        },
        shareChooseGroup() {
            // 显示分组列表
            var curPath = this.$router.history.current.path;
            this.$router.replace(curPath + '/choosegroup');
        },
        shareConfirmChange(params) {
            // 处理分组数据
            if(!this.otherShareFormData.group) {
                this.$store.state.othershare.shareFormData.f_group = 0
            }else {
                this.$store.state.othershare.shareFormData.f_group = this.otherShareFormData.groupId;
                this.$store.state.othershare.shareFormData = _.omit(this.otherShareFormData, ['group', 'groupId']);
            }
            console.log('shareConfirmChange', this.$store.state.othershare.shareFormData, this.otherShareFormData)
            var me = this;
            switch(this.otherShareData.shareType){
                case 3:
                    // 保存新的批盘
                    me.$store.dispatch('othershare/submitSaveToNew', {
                        cb: function(data){
                            // todo:走配置信息:根据批盘论盘type值来配
                            me.$toast('已自动保存到对应八字下面\n『他人批盘』中');
                            me.$store.state.comment.detailInfo = data;
                            me.$store.state.detail.personInfo = data;
                            me.$store.state.comment.otherSaved = true;
                            me.$store.state.comment.fromOtherComment = true;
                            me.$store.state.comment.curSubTab = 4;
                            me.$store.state.comment.otherShareTitle = me.otherShareFormData.shareTitle;
                            // 修改URL
                            me.$router.replace('/comment/othercomment/' + data.id)
                            setTimeout(() => {
                                SHARE.initConfigShare();
                            }, 10);
                            
                            // 执行UI层组件内的回调函数
                            if(params && params.cb && typeof(params.cb) == 'function') {
                                params.cb();
                            }
                        }
                    });
                    break;
                case 6:
                case 7:
                    // 保存新的论盘
                    me.$store.dispatch('othershare/submitSaveDiscussToNew', {
                        cb: function(data) {
                            me.$toast('已保存到对应八字下面的论盘中');

                            // 执行UI层组件内的回调函数
                            if(params && params.cb && typeof(params.cb) == 'function') {
                                params.cb();
                            }
                        }
                    })
                    break;
                default:
                    break;
            }
            
        },
        clickShareSaveOverlay() {
            this.$store.state.othershare.showShareSavePop = false;
        },
        shareConfirmSave(params) {
            console.log('shareConfirmSave-------', this.otherShareSaveData, this.otherShareData)
            if((this.otherShareData.lunpan && this.otherShareSaveData.shareTitle == this.otherShareData.lunpan.f_title) ||
                (this.otherShareData.f_title && this.otherShareSaveData.shareTitle == this.otherShareData.f_title)) {
                console.log('名称未改变');
            }
            
            // 批盘分享
            if(this.otherShareData.shareType == 3) {
                this.$store.dispatch('othershare/submitEditOtherShare');
                // 显示底部导航栏并切换到他人批盘，隐藏保存按钮；
                this.$store.state.comment.otherSaved = true;
                this.$store.state.comment.curSubTab = 4;
                this.$store.state.comment.otherShareTitle = this.otherShareData.title;
                // 修改URL
                this.$router.replace('/comment/othercomment/' + this.otherShareSaveData.detailId)
                setTimeout(() => {
                    SHARE.initConfigShare();
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }, 10);
            }else if(this.otherShareData.shareType == 6 || this.otherShareData.shareType == 7) {
                var me = this;
                this.$store.dispatch('othershare/submitEditDiscussShare', {
                    cb: function() {
                        me.$toast('已保存到对应八字下面的论盘中');

                        if(params && params.cb && typeof(params.cb) == 'function') {
                            params.cb();
                        }
                    }
                });
            }else {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            }
        }
    }
}
</script>